import { useTranslation } from 'react-i18next'
import { useProductApi } from '../../pages/organizer/events/api/useProductApi'
import { TripDataDialogMain } from './TripDataDialogMain'
import { UidUtils } from '../../utils/uid-utils'
import { format } from 'date-fns'

/**
 * TODO: For now, I'm substituting full_price and payment_due_date for the base items
 * Since we're not changing them on the client app yet, this is to prevent any issues with
 * displaying and adding prices and dates for currently active camps/colonies.
 */
export const AddTripDataDialog = ({ open, product, onClose }) => {
  const { createTrip } = useProductApi()
  const { t } = useTranslation()

  const handleSave = async (data: any) => {
    const productData: any = {
      ...product,
      ...data,
      start_date: format(data.start_date, 'yyyy-MM-dd'),
      end_date: format(data.end_date, 'yyyy-MM-dd')
    }

    productData.payment_due_date = format(data.payment_due_date, 'yyyy-MM-dd')

    return createTrip(product.id, productData)
  }

  return (
    <TripDataDialogMain
      open={open}
      product={product}
      onClose={onClose}
      onSubmit={handleSave}
          defaultValues={{
            id: UidUtils.generateUid('trip_'),
            product_id: product.id,
            product_type: product.type,
            name: '',
            start_date: '',
            end_date: '',
            currency: '',
            payment_due_date: ''
          }}
      headerTitle={t('ui.trips.add_term', 'Dodaj termin')}
    />
  )
}
